import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { WorkspacePrebidModule } from 'features/globalSetup/types/workspacePrebidModule'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { DELETE_WORKSPACE_PREBID_MODULE } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseDeleteWorkspacePrebidModule, useDeleteWorkspacePrebidModuleProps } from './types'

export const useDeleteWorkspacePrebidModule = ({
  prebidModule,
}: useDeleteWorkspacePrebidModuleProps): UseDeleteWorkspacePrebidModule => {
  const { t } = useTranslation('features/globalSetup')
  const { enqueueSnackbar } = useSnackbar()

  const { isPending, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: DELETE_WORKSPACE_PREBID_MODULE,
    onCompleted: async (data: Data): Promise<void> => {
      const { deleteWorkspacePrebidModule } = data
      const prebidModuleName = prebidModule.name

      if (deleteWorkspacePrebidModule) {
        const { errors } = deleteWorkspacePrebidModule

        if (errors && errors.length > 0) {
          enqueueSnackbar(
            t('prebid.modules.common.list.delete.action.error', {
              prebidModuleName,
            }),
            { variant: 'error' },
          )
        }
      } else {
        enqueueSnackbar(
          t('prebid.modules.common.list.delete.action.success', { prebidModuleName }),
          { variant: 'success' },
        )
      }
    },
    queriesToInvalidate: ['workspacePrebidModules'],
  })

  const destroy: UseDeleteWorkspacePrebidModule['destroy'] = (id: WorkspacePrebidModule['id']) =>
    mutateAsync({
      input: { id },
    })

  return {
    destroy,
    loading: isPending,
  }
}
